module.exports = __webpack_public_path__ + "static/media/dg_1.2f708d82.png";